import styled from "styled-components";

export const AppInputWrapper = styled.div<{
  $leftIcon?: boolean;
  $iconRight?: boolean;
  $success?: boolean;
  overrideBorderBottomColor?: string;
}>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;

  input {
    width: 100%;
    padding: 8px;
    padding-left: ${({ $leftIcon }): string => ($leftIcon ? "30px" : "0px")};
    padding-right: ${({ $iconRight }): string => ($iconRight ? "30px" : "0px")};
    border: none;
    border-bottom: 1px solid
      ${({ theme, $success, overrideBorderBottomColor }): string =>
        overrideBorderBottomColor
          ? overrideBorderBottomColor
          : $success
            ? theme.colors.green
            : theme.colors.yellow};
    background-color: transparent;
    color: ${({ theme }): string => theme.colors.white};
    font-size: 1rem;

    &:focus {
      border-bottom: 2px solid
        ${({ theme, $success, overrideBorderBottomColor }): string =>
          overrideBorderBottomColor
            ? overrideBorderBottomColor
            : $success
              ? theme.colors.green
              : theme.colors.yellow};
      outline: none;
    }

    &.error {
      border-bottom: 1px solid ${({ theme }): string => theme.colors.red};
    }
    &.success {
      border-bottom: 1px solid ${({ theme }): string => theme.colors.green};
    }
  }

  .input-icon {
    position: absolute;
    font-size: 18px;
    color: ${({ theme }): string => theme.colors.yellow};
  }
  .input-icon-right {
    position: absolute;
    font-size: 18px;
    right: 0;
    color: ${({ theme }): string => theme.colors.yellow};
    z-index: 10;
    pointer-events: none;

    > * {
      pointer-events: auto;
    }
  }
`;

export const InputLabel = styled.label`
  margin-top: 1rem;
  font-size: 1rem;
  color: ${({ theme }): string => theme.colors.yellow};
  font-weight: bold;
`;

export const ErrorMessage = styled.p`
  color: red;
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;

export const ErrorLabel = styled.p`
  color: ${({ theme }): string => theme.colors.red};
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;
